export const devices = {
  smallMobile: '@media screen and (max-width: 375px)',
  mobile: '@media screen and (max-width: 750px)',
  largeMobile: '@media screen and (max-width: 768px)',
  tablet: '@media screen and (max-width: 1200px)',
  smallDesktop: '@media screen and (max-width: 1440px)',
}